module.exports = {
	"fi": {
		"hqm": {
			"support-button": "Pyydä tukea",
			"support-page": {
				"create-ticket": {
					"title": "Pyydä tukea",
					"instructions": "Lähetä alla oleva pyyntö ja otamme sinuun yhteyttä.",
					"fields": {
						"mid": {
							"label": "Valitse kauppa",
							"validation": "Kauppa on pakollinen"
						},
						"topic": {
							"question": "Mitä kysymyksesi koskee?",
							"label": "Valitse aihe",
							"validation": "Aihe on pakollinen",
							"options": {
								"orders": "Tilaukset",
								"settlements": "Tilitykset",
								"agreements": "Sopimukset",
								"technical_issues": "Tekniset ongelmat",
								"others": "Muut"
							}
						},
						"subject": {
							"label": "Aiherivi",
							"validation": "Aiherivi on pakollinen"
						},
						"description": {
							"label": "Viesti",
							"validation": "Kuvaus on pakollinen"
						},
						"attachment": {
							"label": "Lisää liitteitä",
							"button": "Lataa",
							"info": "Näyttökaappauksen avulla selvitämme ongelman nopeammin.",
							"supportedFileTypes": "Tuetut tiedostomuodot: .png, .jpg, .pdf",
							"error": "Tiedostojen koko ei saa ylittää kokonaisuudessaan 15 Mt"
						}
					},
					"submit": "Lähetä pyyntö",
					"service-unavailable-error": "Hups! Jokin meni pieleen, yritä uudelleen muutaman minuutin kuluttua. Mikäli ongelma jatkuu,  {link}.",
					"contact-page-link": "ota meihin yhteyttä"
				},
				"view-ticket": {
					"title": "Valmista on!",
					"details": "Olemme vastaanottaneet pyyntösi ja vastaamme sinulle pian. Tässä ovat tietosi:",
					"ticket": "Pyynnön numero {ticketId}",
					"email": "Sähköposti: {email}",
					"status": "Voit seurata tilaa tukisivullamme.",
					"track": "Seuraa tilaa"
				}
			},
			"popup": {
				"yes": "Kyllä",
				"no": "Ei",
				"somethingElse": "Tarvitsen apua jossakin muussa asiassa"
			},
			"header": {
				"homeLink": "Nollaa"
			},
			"home": {
				"greeting": "Hei {givenName}! Miten voimme auttaa sinua?",
				"topics": "Missä asiassa tarvitset apua?"
			},
			"topics": {
				"expandButton": "Lisää"
			},
			"moreHelp": {
				"relatedArticlesParagraph": "Olemme pahoillamme, ettei tästä ollut apua. Kenties jostakin näistä artikkeleista on sinulle apua?",
				"stillQuestionsTitle": "Onko sinulla vielä kysyttävää?",
				"stillQuestionsParagraph": "Voit myös ottaa meihin suoraan yhteyttä.",
				"contactButton": "Ota meihin yhteyttä"
			},
			"feedback": {
				"title": "Oliko tästä apua?",
				"optionYes": "Kyllä, tästä oli apua",
				"optionNo": "Ei, tarvitsen vielä apua",
				"positiveFeedback": "Kiitos positiivisesta palautteestasi! Se auttaa meitä tarjoamaan sinulle tulevaisuudessa sinua kiinnostavia artikkeleja."
			},
			"freeTextFeedback": {
				"title": "Auta meitä parantamaan toimintaamme",
				"placeholder": "Miksi tämä sisältö ei ollut mielestäsi hyödyllistä?",
				"submitButton": "Lähetä",
				"feedbackMessage": "Kiitos palautteestasi! Se auttaa meitä tarjoamaan sinulle tulevaisuudessa sinua kiinnostavia artikkeleja."
			},
			"relatedContent": {
				"title": "Asiaan liittyvä sisältö"
			},
			"search": {
				"buttonLabel": "Etsi",
				"input": "Hae artikkeleja...",
				"loading": "Ladataan...",
				"results": {
					"contact": "Etkö löydä apua ongelmaasi?",
					"empty": "Valitettavasti haullasi ei löytynyt yhtään tulosta. Yritä hakea toisella hakusanalla.",
					"singleTopicFound": "Löysimme 1 aiheen",
					"multipleTopicsFound": "Löysimme {count} aihetta",
					"singleArticleFound": "Löysimme 1 artikkelin",
					"multipleArticlesFound": "Löysimme {count} artikkelia"
				}
			},
			"contact": {
				"title": "Ota meihin yhteyttä",
				"channelsIntro": "Ota meihin yhteyttä, jotta voimme auttaa sinua.",
				"businessDetailsTitle": "Yrityksesi tiedot",
				"businessDetailsName": "Yrityksen nimi",
				"businessDetailsEmail": "Sähköpostiosoite",
				"businessDetailsMid": "Kaupan tunnus",
				"phone": {
					"title": "Soita meille",
					"paragraph": "Voit soittaa meille arkisin virka-aikaan. Jos olet Ruotsissa tai Yhdistyneessä kuningaskunnassa, voit soittaa meille myös viikonloppuisin klo 10–16."
				},
				"chat": {
					"title": "Keskustele kanssamme chatissa",
					"paragraph": "Helpoin ja nopein tapa ottaa yhteys tukeen. Chat on tällä tällä hetkellä auki.",
					"button": "Avaa chat"
				},
				"email": {
					"title": "Lähetä meille sähköpostia",
					"paragraph": "Lähetä meille sähköpostia ja otamme sinuun yhteyttä mahdollisimman pian."
				}
			},
			"errorBoundary": {
				"title": "Jokin meni vikaan",
				"message": "Pahoittelut, tapahtui virhe. Nollaa napsauttamalla alla olevaa painiketta ja sulje tämä sivupalkki.",
				"resetButton": "Nollaa",
				"errorId": "Virhetunnus: {errorId}"
			},
			"tour": {
				"prev": "Edellinen",
				"next": "Seuraava",
				"done": "Valmis"
			},
			"notAvailableMobile": {
				"title": "Ei saatavilla",
				"buttonBack": "Takaisin",
				"paragraph": "Tämä sisältö ei ole saatavilla laitteellasi. Yritä avata se laitteella, jossa on suurempi näyttö, kuten pöytätietokoneella."
			},
			"shareButton": {
				"title": {
					"article": "Jaa linkki tähän artikkeliin",
					"topic": "Jaa linkki tähän aiheeseen",
					"tour": "Jaa linkki tähän kierrokseen"
				},
				"radioItemHome": "Etusivusovellus",
				"descriptionHome": "Avaa tukiartikkelin Kauppiasportaalin etusivulla",
				"radioItemCurrent": "Nykyinen sivu",
				"descriptionCurrent": "Avaa tukiartikkelin nykyisellä sivulla"
			}
		},
		"orientation": {
			"title": "Opi lisää aiheesta ..."
		},
		"core": {
			"alert": {
				"message": "Jokin meni vikaan! Yritä uudelleen.",
				"correlationIdLabel": "Korrelaatiotunnus:"
			},
			"header": {
				"title": "Kauppiasportaali"
			},
			"usermenu": {
				"language": "Kieli",
				"country": "Maa",
				"timezone": "Aikavyöhyke",
				"logout": "Kirjaudu ulos",
				"profile": "Profiili",
				"changeProfile": "Muokkaa",
				"tooltip": "Profiilisi"
			},
			"appsmenu": {
				"defaultTooltip": "Omat sovelluksesi",
				"initialTooltip": "Löydät omat sovelluksesi täältä.",
				"newAppsTooltip": "Meillä on sinulle uusia sovelluksia!"
			},
			"helpful-question-mark": {
				"helpLabel": "Apua"
			},
			"languages": {
				"da": "Tanska",
				"de": "Saksa",
				"en": "Englanti",
				"en_GB": "Englanti (UK)",
				"en_US": "Englanti (US)",
				"es": "Espanja",
				"fi": "Suomi",
				"fr": "Ranska",
				"it": "Italia",
				"nl": "Hollanti",
				"no": "Norja",
				"sv": "Ruotsi"
			},
			"countries": {
				"de": "Saksa",
				"dk": "Tanska",
				"fi": "Suomi",
				"gb": "Iso-Britannia",
				"nl": "Alankomaat",
				"no": "Norja",
				"se": "Ruotsi",
				"us": "Yhdysvallat"
			},
			"selectLanguage": {
				"title": "Valitse kieli",
				"paragraph": "Tämä on nyt oletuskielesi.",
				"submit": "OK"
			},
			"selectCountry": {
				"title": "Valitse maa",
				"paragraph": "Tämä on nyt oletusmaasi.",
				"submit": "OK"
			},
			"updateProfile": {
				"title": "Päivitä tiedot",
				"submit": "OK",
				"emailLabel": "Sähköpostiosoite",
				"firstNameLabel": "Etunimi",
				"lastNameLabel": "Sukunimi",
				"resetPasswordLabel": "Nollaa salasana",
				"resetPasswordSuccessLabel": "Sähköposti salasanan nollaamiseksi lähetetty",
				"resetPasswordErrorLabel": "Virhe salasanan nollaussähköpostin lähettämisessä",
				"error": "Tietojen päivitys epäonnistui"
			},
			"footer": {
				"copyright": {
					"eu": "Tekijänoikeus © 2005-{currentYear} Klarna Bank AB (publ). Kaikki oikeudet pidätetään",
					"oc": "Tekijänoikeus © 2005-{currentYear} Klarna Australia Pty Ltd, ABN # 82 635 912 579",
					"us": "Tekijänoikeus © 2005-{currentYear} Klarna Inc. NMLS #1353190, 629 N. High Street, Third Floor, Columbus, OH 43215"
				},
				"terms": "Ehdot"
			},
			"accessDenied": {
				"title": "Tarvitset lisäpääsyn tätä sivua varten. ",
				"message": "Jos sinulla on kysyttävää, olethan yhteydessä ylläpitäjääsi tai Klarnaan."
			},
			"midSelector": {
				"label": "Kauppa"
			},
			"storeSelector": {
				"label": "Kauppa"
			},
			"storesSelector": {
				"closeText": "Valmis",
				"closeTextWithSelection": "Sovella # valintaan",
				"deselectAllOptionText": "Tyhjennä valinta",
				"emptyStateText": "Kauppoja ei löytynyt",
				"label": "Kaupat",
				"searchFieldLabel": "Hae kaupan mukaan",
				"selectAllOptionText": "Valitse kaikki kaupat",
				"selectedAllText": "Kaikki kaupat",
				"selectedText": "# kaupalle"
			},
			"pagination": {
				"ofLabel": "/",
				"noResultsLabel": "Ei tuloksia"
			},
			"dateRangePicker": {
				"startLabel": "Alkaen",
				"endLabel": "Asti",
				"months": {
					"january": "Tammikuu",
					"february": "Helmikuu",
					"march": "Maaliskuu",
					"april": "Huhtikuu",
					"may": "Toukokuu",
					"june": "Kesäkuu",
					"july": "Heinäkuu",
					"august": "Elokuu",
					"september": "Syyskuu",
					"october": "Lokakuu",
					"november": "Marraskuu",
					"december": "Joulukuu"
				},
				"weekDaysShort": {
					"monday": "M",
					"tuesday": "T",
					"wednesday": "K",
					"thursday": "T",
					"friday": "P",
					"saturday": "S",
					"sunday": "S"
				}
			},
			"appIcon": {
				"newLabel": "UUSI"
			},
			"appCategory": {
				"dayToDay": "Päivittäisiin",
				"nko": "Klarna Online",
				"tools": "Työkalut",
				"preferences": "Asetukset"
			},
			"apps": {
				"home-fe": {
					"title": "Etusivu"
				},
				"nko-app": {
					"title": "Klarna Online -sovellukset"
				},
				"orders-fe": {
					"title": "Tilaukset",
					"description": "Etsi ja hallinnoi tilauksiasi Klarnasta.",
					"nkoLinkText": "Katso vanhempia tilauksia"
				},
				"nko-orders": {
					"title": "Tilaukset (KO)",
					"description": "Etsi ja hallinnoi Klarna Onlinen kautta tekemiäsi tilauksia."
				},
				"settlements-fe": {
					"title": "Tilitykset",
					"description": "Katsele tapahtumiasi ja luo täsmäytysraportteja.",
					"nkoLinkText": "Katso vanhempia raportteja"
				},
				"nko-settlements": {
					"title": "Tilitykset (KO)",
					"description": "Etsi tilaus- ja maksuraportteja Klarna Onlinesta."
				},
				"logs-app-fe": {
					"title": "Lokitiedot",
					"description": "Etsi API-lokeja ratkaistaksesi integrointiongelmia."
				},
				"users-fe": {
					"title": "Käyttäjät",
					"description": "Kutsu uusia käyttäjiä ja hallinnoi nykyisiä käyttäjiä portaalissa."
				},
				"settings-fe": {
					"title": "Asetukset",
					"description": "Pyydä Klarna API -tunnistetietosi ja hallinnoi kaupan asetuksia."
				},
				"nko-settings": {
					"title": "Asetukset (KO)",
					"description": "Hallitse kauppasi asetuksia, raportteja ja yhteystietoja."
				},
				"seller-fe": {
					"title": "Point of Sale",
					"description": "Luo uusia tilauksia Klarnan kaupansisäisen ratkaisun avulla."
				},
				"products-fe": {
					"title": "Tuotteet",
					"description": "Opastaa sinua matkallasi, jotta saat kaiken irti Klarnasta."
				},
				"upstream-fe": {
					"title": "Viestintä sivulla",
					"description": "Myy enemmän räätälöityjen ja personoitujen rahoitustarjousten avulla."
				},
				"lending-fe": {
					"title": "Kauppiasrahoitus",
					"description": "Yritysrahoitusta yksinkertaisesti."
				},
				"branding-fe": {
					"title": "Brändäys",
					"description": "Hallitse sitä, kuinka oma brändisi näkyy Klarnassa."
				},
				"disputes-fe": {
					"title": "Twister",
					"description": "Käsittele kiista-asioitasi."
				},
				"logistics-fe": {
					"title": "Logistiikka",
					"description": "Hallitse kaikkea logistiikkaasi yhdestä paikasta."
				},
				"ob-transactions-fe": {
					"title": "Tapahtumat",
					"description": "Avaa pankkitapahtumat"
				},
				"developers": {
					"title": "Kehittäjät"
				},
				"product-upgrade-fe": {
					"title": "Tuotepäivitys"
				},
				"marketing": {
					"title": "Markkinointi",
					"description": "Tartu markkinointimateriaaleihin täällä ja kasvata liiketoimintaasi."
				},
				"business-card-fe": {
					"title": "Yrityskortti",
					"description": "Tulossa pian"
				},
				"support": {
					"title": "Tuki",
					"description": "Tarkastele ja hallitse tukipyyntöjäsi."
				}
			},
			"ui": {
				"buttons": {
					"backButton": "Takaisin"
				}
			},
			"errorBoundary": {
				"contact": "Yritä päivittää sivua. {br}Jos virhe jatkuu, ota yhteyttä <supportLink>Kauppiastukeen</supportLink> ja anna tunnus {errorId}",
				"errorDescription": "Virhetunnus - {errorId}",
				"reloadButton": "Päivitä",
				"title": "Tapahtui valitettavasti virhe"
			},
			"maintenance": {
				"pageTitle": "Ylläpito",
				"title": "Kauppiasportaalissa on käynnissä aikataulutettu huolto",
				"summary": "Palaamme pian",
				"scheduledSummary": "Palaamme {until}"
			}
		},
		"blackFriday": {
			"v1": {
				"title": "Black Friday",
				"intro": "Yksi vuoden tärkeimmistä myyntipäivistä on tulossa. Black Fridayn aikana toimitamme sinulle lähes reaaliaikaisia tietoja myynneistäsi. Valmistaudutaan sillä välin menestykseen!",
				"countdown": "Alkaa #dd #ht #mp #ss…",
				"box1": {
					"title": "3,5-kertainen kulutus*",
					"text": "Viime vuonna Klarnan shoppailijat* kuluttivat keskimäärin 3,5 kertaa enemmän Black Fridayn aikana kuin minä tahansa muuna päivänä samana vuonna.",
					"footnote": "*Kaikkien Klarna-kauppiaiden kategorioiden ja alueiden keskiarvo."
				},
				"box2": {
					"title": "2,5-kertainen myyntivolyymi*",
					"text": "Viime vuonna Klarna-kauppiaat saavuttivat 2,5 kertaa suuremman myyntivolyymin Black Fridayn aikana kuin minä tahansa muuna päivänä samana vuonna.",
					"footnote": "*Kaikkien Klarna-kauppiaiden kategorioiden ja alueiden keskiarvo."
				},
				"sectionTitle": "Kasvatetaan Black Fridayn myyntiäsi",
				"marketing": {
					"title": "Markkinoi liiketoimintaasi ennen Black Fridaytä ja sen aikana",
					"text": "Houkuttele lisää shoppailijoita kauppaasi Black Friday -shoppailukauden aikana maksuttomien sosiaalisen median materiaalien ja sähköpostikampanjoiden avulla."
				},
				"branding": {
					"title": "Tule nähdyksi Klarna-sovelluksessa",
					"text": "12 miljoonaa shoppailijaa käyttää Klarna-sovellusta joka kuukausi. Varmista näkyvyytesi sovelluksessa tänä Black Fridaynä lisäämällä ja päivittämällä brändisi tiedot täällä Kauppiasportaalissa."
				},
				"cta": "Aloita heti",
				"close": "Sulje"
			},
			"v2": {
				"title": "Black Friday week",
				"orderVolume": "Tilausmäärä",
				"orderCountTitle": "Luodut tilaukset",
				"orderCount": "{count} tilausta",
				"box": {
					"title": "Haluatko lisätä konversiota?",
					"subtitle1": "On-site messaging",
					"subtitle2": "Tiedottava kampanjaviesti.",
					"text": "On-site messaging-työkalumme avulla tehostat myyntiäsi ja tilauksen keskimääräistä arvoa kampanjaviestien ansiosta. Kerro asiakkaillesi heidän maksuvaihtoehdoistaan ostoskokemuksen alusta loppuun asti.",
					"cta": "Aloita heti"
				},
				"selector": {
					"done": "Valmis",
					"applySelection": "Sovella # valintaan",
					"selectAll": "Valitse kaikki",
					"allOptions": "Kaikki vaihtoehdot valittu",
					"someOptions": "# vaihtoehtoa valittu",
					"storeMultiSelectLabel": "Valitse # kauppaa",
					"allStores": "Kaikki kaupat"
				},
				"currencyLabel": "Valitse valuutta",
				"storeLabel": "Valitse kauppa"
			},
			"v3": {
				"title": "Black Friday week",
				"text": "Tässä naet myyntilukusi yhdeltä vuoden tärkeimmista myyntiviikoista.",
				"summaryTitle": "Yhteenveto",
				"orderVolume": "Kokonaismäärä",
				"orderCount": "Tilaukset yhteensä",
				"summaryRange": "23-30 November",
				"comparisonLastWeek": "verrattuna samaan päivään viime viikolla",
				"tabs": {
					"monday": "Maanantai",
					"tuesday": "Tiistai",
					"wednesday": "Keskiviikko",
					"thursday": "Torstai",
					"blackFriday": "Black Friday",
					"saturday": "Lauantai",
					"sunday": "Sunnuntai",
					"cyberMonday": "Cyber Monday"
				}
			}
		}
	}
};